export enum BorrowerTypeEnum {
    Borrower = "Borrower",
    CoBorrower = "CoBorrower",
    Both = "Both"
}